module.exports = __webpack_public_path__ + "img/lc.f7a9bbf5.svg";